var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8OutOfStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f44336",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,6c-0.828,0 -1.5,0.671 -1.5,1.5v29c0,3.033 2.468,5.5 5.5,5.5h12.55664c-0.595,-0.928 -1.07783,-1.932 -1.42383,-3h-11.13281c-1.379,0 -2.5,-1.122 -2.5,-2.5v-27.5h30v13.63477c1.068,0.345 2.073,0.82883 3,1.42383v-16.55859c0,-0.829 -0.672,-1.5 -1.5,-1.5zM20.5,13c-0.54095,-0.00765 -1.04412,0.27656 -1.31683,0.74381c-0.27271,0.46725 -0.27271,1.04514 0,1.51238c0.27271,0.46725 0.77588,0.75146 1.31683,0.74381h7c0.54095,0.00765 1.04412,-0.27656 1.31683,-0.74381c0.27271,-0.46725 0.27271,-1.04514 0,-1.51238c-0.27271,-0.46725 -0.77588,-0.75146 -1.31683,-0.74381zM35,24c-6.065,0 -11,4.935 -11,11c0,6.065 4.935,11 11,11c6.065,0 11,-4.935 11,-11c0,-6.065 -4.935,-11 -11,-11zM35,27c1.665,0 3.21019,0.51272 4.49219,1.38672l-11.10547,11.10547c-0.874,-1.282 -1.38672,-2.82719 -1.38672,-4.49219c0,-4.411 3.589,-8 8,-8zM41.61328,30.50781c0.874,1.282 1.38672,2.82719 1.38672,4.49219c0,4.411 -3.589,8 -8,8c-1.665,0 -3.21019,-0.51272 -4.49219,-1.38672z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OutOfStock);
export default __webpack_public_path__ + "static/media/icons8-out-of-stock.82bd30aed8b04505e258cd93a3bfc34f.svg";
export { ForwardRef as ReactComponent };